import React from 'react';
import { Button } from 'clad';

class ActionButton extends React.PureComponent {
    render() {
        const { props } = this;
        return <Button {...props} type="primary" />;
    }
}

export default ActionButton;
